import Bowser from 'bowser';

checkBrowser();
function checkBrowser() {
  const BROWSER_MINIMUM_VERSION = {
    chrome: 73,
    firefox: 65,
    edge: 80,
    ie: 12,
  };

  const browser = Bowser.getParser(window.navigator.userAgent);
  const browserName = browser.getBrowserName();
  const browserVersion = parseInt(browser.getBrowserVersion());

  if (
    (browserName === 'Chrome' && browserVersion < BROWSER_MINIMUM_VERSION.chrome) ||
    (browserName === 'Firefox' && browserVersion < BROWSER_MINIMUM_VERSION.firefox) ||
    (browserName === 'Microsoft Edge' && browserVersion < BROWSER_MINIMUM_VERSION.edge) ||
    (browserName === 'Internet Explorer' && browserVersion < BROWSER_MINIMUM_VERSION.ie)
  ) {
    document.location.href = '/alert/obsoleteBrowser';
  }
}
